import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'jhi-custom-input',
    templateUrl: './custom-input.component.html',
    styles: []
})
export class CustomInputComponent implements OnInit {
    @Input() id = '';
    @Input() type: string;
    @Input() disabled = false;
    @Input() submitted = false;
    @Input() fControlName: any;
    @Input() formGetter: any;
    @Input() label = '';

    constructor() {}

    ngOnInit() {}
}
